import { render } from "./VirtuallyInfo.vue?vue&type=template&id=69acef64&scoped=true"
import script from "./VirtuallyInfo.vue?vue&type=script&lang=ts"
export * from "./VirtuallyInfo.vue?vue&type=script&lang=ts"

import "./VirtuallyInfo.vue?vue&type=style&index=0&id=69acef64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69acef64"

export default script